import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Moon, Activity, Sun, Brain, Battery } from 'lucide-react';
export function WhatYouGet() {
  return <section className="py-16 md:py-24 bg-[#0a0a0a] relative" data-id="element-199">
      <div className="max-w-6xl mx-auto px-4" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 md:mb-20" data-id="element-201">
          <h2 className="text-2xl md:text-5xl font-black text-white mb-4" data-id="element-202">
            ¿Qué Recibes <span className="text-cyan-400" data-id="element-203">Exactamente?</span>
          </h2>
          <div className="h-1 w-24 bg-cyan-500 mx-auto rounded-full" data-id="element-204" />
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12" data-id="element-205">
          {/* Main Product */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#111] rounded-2xl p-5 md:p-8 border border-white/5 group" data-id="element-206">
            <div className="mb-6 md:mb-8 relative" data-id="element-207">
              <div className="absolute -inset-4 bg-cyan-500/10 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-208" />
              <img src="https://cdn.magicpatterns.com/uploads/8E9wobJo46Jd3gvNc4BkAk/heylloyd-generated-1769625652820.png" alt="Guía Principal" className="w-36 md:w-48 mx-auto shadow-2xl relative z-10" data-id="element-209" />
            </div>

            <h3 className="text-xl md:text-2xl font-bold text-white mb-2 text-center" data-id="element-210">
              1) El PDF Principal
            </h3>
            <p className="text-cyan-400 text-center font-medium mb-4 md:mb-6 text-sm md:text-base" data-id="element-211">
              Guía Longevidad Activa 35+
            </p>

            <ul className="space-y-3 md:space-y-4 text-gray-300" data-id="element-212">
              <li className="flex gap-3" data-id="element-213">
                <Activity className="text-cyan-500 shrink-0" size={18} data-id="element-214" />
                <span className="text-sm md:text-base" data-id="element-215">
                  Test rápido para identificar tu nivel de desregulación.
                </span>
              </li>
              <li className="flex gap-3" data-id="element-216">
                <Sun className="text-cyan-500 shrink-0" size={18} data-id="element-217" />
                <span className="text-sm md:text-base" data-id="element-218">
                  Las 4 palancas clave: Luz, Sueño, Sistema Nervioso y Energía
                  Metabólica.
                </span>
              </li>
              <li className="flex gap-3" data-id="element-219">
                <BookOpen className="text-cyan-500 shrink-0" size={18} data-id="element-220" />
                <span className="text-sm md:text-base" data-id="element-221">
                  Plan de 7 días, paso a paso, para re-regular tu energía.
                </span>
              </li>
              <li className="flex gap-3" data-id="element-222">
                <Battery className="text-cyan-500 shrink-0" size={18} data-id="element-223" />
                <span className="text-sm md:text-base" data-id="element-224">
                  Tracker para medir tu progreso: sueño, energía AM/PM, bajones.
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Bonus Product */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-[#111] rounded-2xl p-5 md:p-8 border border-white/5 group" data-id="element-225">
            <div className="mb-6 md:mb-8 relative" data-id="element-226">
              <div className="absolute -inset-4 bg-red-500/10 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-227" />
              <img src="https://cdn.magicpatterns.com/uploads/nsfENz9HNs12fKgnkbgs3i/heylloyd-image-1769626254985.png" alt="Bonus Rutina AM/PM + Tracker" className="w-36 md:w-48 mx-auto shadow-2xl relative z-10 rounded-lg" data-id="element-228" />
            </div>

            <div className="text-center" data-id="element-229">
              <span className="inline-block bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full mb-3 md:mb-4" data-id="element-230">
                BONUS GRATUITO
              </span>
            </div>

            <h3 className="text-xl md:text-2xl font-bold text-white mb-2 text-center" data-id="element-231">
              2) Rutina AM/PM + Tracker
            </h3>
            <p className="text-red-400 text-center font-medium mb-4 md:mb-6 text-sm md:text-base" data-id="element-232">
              Imprimible Exclusivo
            </p>

            <ul className="space-y-3 md:space-y-4 text-gray-300" data-id="element-233">
              <li className="flex gap-3" data-id="element-234">
                <Sun className="text-red-500 shrink-0" size={18} data-id="element-235" />
                <span className="text-sm md:text-base" data-id="element-236">
                  Rutina AM (mañana) de 10 minutos para arrancar con energía.
                </span>
              </li>
              <li className="flex gap-3" data-id="element-237">
                <Moon className="text-red-500 shrink-0" size={18} data-id="element-238" />
                <span className="text-sm md:text-base" data-id="element-239">
                  Rutina PM (noche) de 10 minutos para preparar sueño profundo.
                </span>
              </li>
              <li className="flex gap-3" data-id="element-240">
                <Brain className="text-red-500 shrink-0" size={18} data-id="element-241" />
                <span className="text-sm md:text-base" data-id="element-242">
                  Tracker de 7 días para imprimir y anotar tus puntos clave.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mt-10 md:mt-16 p-4 md:p-6 bg-cyan-900/10 border border-cyan-500/20 rounded-xl max-w-2xl mx-auto" data-id="element-243">
          <p className="text-sm md:text-lg text-cyan-100 font-medium" data-id="element-244">
            Descarga inmediata. Lo lees en una sentada y aplicas el primer día
            hoy mismo.
          </p>
        </motion.div>
      </div>
    </section>;
}